const theme = {
  colors: {
    primary: '#18453B',           // Michigan State Green
    secondary: '#000000',         // Pure black
    accent: '#5F8D4E',            // Lighter green accent
    background: '#000000',        // Pure black background
    surface: '#1A1A1A',           // Dark surface
    text: '#FFFFFF',              // White text
    textSecondary: '#9CA3AF',     // Light gray text
    textLight: '#6B7280',         // Medium gray text
    divider: '#2A2A2A',           // Dark divider
    success: '#18453B',           // Green
    warning: '#FFB800',           // Orange
    error: '#FF4444',             // Red
    lightGray: '#2A2A2A',         // Light gray surface
    mediumGray: '#404040',        // Medium gray
    darkGreen: '#18453B',         // Dark green
    border: '#2A2A2A',            // Dark border
    shadow: 'rgba(0, 0, 0, 0.5)', // Dark shadow
  },
  fonts: {
    primary: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    secondary: '"Inter", sans-serif',
    headline: '"Inter", sans-serif',
    body: '"Inter", sans-serif',
    accent: '"Inter", sans-serif',
    display: '"Inter", sans-serif',
  },
  fontSizes: {
    xs: '0.75rem',      // 12px
    sm: '0.875rem',     // 14px
    base: '1rem',       // 16px
    lg: '1.125rem',     // 18px
    xl: '1.25rem',      // 20px
    '2xl': '1.5rem',    // 24px
    '3xl': '1.875rem',  // 30px
    '4xl': '2.25rem',   // 36px
    '5xl': '3rem',      // 48px
    '6xl': '3.75rem',   // 60px
    '7xl': '4.5rem',    // 72px
    '8xl': '6rem',      // 96px
    '9xl': '8rem',      // 128px
  },
  spacing: {
    xs: '0.25rem',      // 4px
    sm: '0.5rem',       // 8px
    md: '1rem',         // 16px
    lg: '1.5rem',       // 24px
    xl: '2rem',         // 32px
    xxl: '3rem',        // 48px
    massive: '4rem',    // 64px
    huge: '6rem',       // 96px
  },
  borderRadius: {
    none: '0',
    sm: '0.125rem',     // 2px
    base: '0.25rem',    // 4px
    md: '0.375rem',     // 6px
    lg: '0.5rem',       // 8px
    xl: '0.75rem',      // 12px
    '2xl': '1rem',      // 16px
    full: '9999px',
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px',
  },
  transitions: {
    fast: '150ms ease',
    normal: '300ms ease',
    slow: '500ms ease',
    elastic: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
    base: '0 1px 3px 0 rgba(0, 0, 0, 0.4), 0 1px 2px 0 rgba(0, 0, 0, 0.3)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -1px rgba(0, 0, 0, 0.3)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -2px rgba(0, 0, 0, 0.3)',
    cardShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    hoverShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
  },
};

export default theme;